export default __webpack_public_path__ + "static/product5-dd891b6287bad27a21577bcf78a48209.jpg";